export default "__VITE_ASSET__d74067da__"